<template>
  	<div>

    	<multiselect 
					v-model="OPZIONE_SELEZIONATA" 
					:track-by="'id'" 
					:value="'Integer'"
					:placeholder="placeholder" 
					open-direction="bottom" 
					:options="options" 
					@select="formattaInUscita"
					:multiple="false" 
					:searchable="true" 
					:loading="isLoading" 
					:internal-search="false" 
					label="text" 
					:clear-on-select="false" 
					:close-on-select="true" 
					:options-limit="300" 
					:limit="3" 
					:max-height="600" 
					:show-no-results="false" 
					:hide-selected="true" 
					@search-change="asyncFind"
					:selectLabel="''"
					:disabled="disabled"
					>
					<!-- 
					<div class="multiselect__clear" v-if="selectedCountries.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
					-->
					<template v-slot:clear >
						<div class="multiselect__clear" v-if=" this.currentId > 0" @mousedown.prevent.stop="clearAll()"></div>
					</template>
					<template v-slot:noOptions >Scrivi min. 3 caratteri</template>

					
		</multiselect>
  	</div>
</template>


<script>
import { computed,ref } from 'vue'
import Multiselect from 'vue-multiselect'
import { utils } from '../../assets/js/utils';



export default {
	name: 'Select2',

	components:{
		Multiselect
	},

	data() {
		return {
			opzioni:new Array(),
			isLoading:false,
			options:new Array(),
			currentId:0,
			isWriting : false,
			currentQuery:"",
			lastApi:""
		};
	},

  	emits: ['update:modelValue','selectedItem'],

  	setup(props, { emit,ref,getCurrentInstance,context }) {
	
		const CURRENT_TIME = new Date().getTime();
		const OPZIONE_SELEZIONATA = computed({          	
			get: () => {
				var t = props.modelValue;
				if (t == undefined || t == null){
					return {id: 0,text:'Selezionare un elemento'};
				}
				var underscore = (t.toString().search("_") > -1);
				if (isNaN(t) && underscore == false){
					return {id: 0,text:'Selezionare un elemento'};
				}		
				else{
					if (t != undefined && underscore == false && t > 0){
						//console.log(" B ");
						var arr = utils.appoggio['select2_'+CURRENT_TIME];
						//SE HO IN CASA UN array valorizzato correttamente, valorizzo la input
						if (arr != undefined && arr.length > 0){
							var item = null;
							for (var kk = 0 ; kk < arr.length ; kk++){
								if (arr[kk].id.toString().search("_") > -1){
									var split = arr[kk].id.split("_");
									for (var zz = 0 ; zz < split.length ; zz++ ){
										if (split[zz] == t){
											return {id: t,text:arr[kk].text};
										}
									}
								}
								else{
									if (arr[kk].id == t){
										item = utils.clone(arr[kk]);
									}
								}
							}

							//var item = utils.array.select(arr,"id",t,1)[0];
							if (item != undefined){
								return {id: t,text:item.text};
							}     
							else{
								if (props.apiselected != null){
									utils.ajax(props.apiselected,{q:t}, (response) => {
										utils.appoggio['select2_'+CURRENT_TIME] = new Array(response.data);
										emit('update:modelValue',"_"+t);
									},false);
									return {id: 0,text:'-'};
								}
								else{
									return {id: 0,text:'-'};
								}
								
							}         							
						}
						else{
							//SE NON HO UN array VALORIZZATO, E HO LE API PER FARE UNA CHIAMATA, PROVO A FARE LA CHIAMATA
							if (props.apiselected != null && props.apiselected != ''){
								utils.ajax(props.apiselected,{q:t}, (response) => {
									utils.appoggio['select2_'+CURRENT_TIME] = new Array(response.data);
									emit('update:modelValue',"_"+t);
								},false);								
								return {id: 0,text:'Loading'};
							}
							else{
								return {id: 0,text:'Selezionare un elemento'};
							}
						}						
					}
					//SE E' STATO VALORIZZATO IN PRECDENZA E E' STATA FATTA LA CHIAMATA PER RECUPERARE L'ELEMENTO
					else if (t != undefined && underscore == true){
						//console.log(" A ");
						var arr = utils.appoggio['select2_'+CURRENT_TIME];
						var arraySplit = t.split("_");
						//MODIFICATO 12/12/2025
						for (var i = 0 ; i < arraySplit.length ; i++){
							if (arraySplit[i] != 0){
								emit('update:modelValue',arraySplit[i]);
								/*
								var item = utils.array.select(arr,"id",t,1)[0];
								if (item != undefined){
									return {id: t,text:item.text};
								}    */
								return {id: 0,text:'Loading'};          								
							}
						}
						return {id: 0,text:'Loading'};   

					}
					else{
						return {id: 0,text: props.placeholder};
					}
				}	
			},
			set : (newVal) => {
				if (newVal == null || newVal.hasOwnProperty("id") == false){
					emit('selectedItem',newVal);
					return newVal;
				}
				emit('selectedItem',newVal.id);
				return newVal;
			}
		});
		return { OPZIONE_SELEZIONATA, CURRENT_TIME };
  	},

	props: {
		modelValue: [String, Array, Number, Object], // previously was `value: String`
		placeholder: {
			type: String,
			default: ''
		},
		api : {
			type : String,
			default:null
		},
		apiselected:{
			type : String,
			default : null
		}, 
		disabled:{
			type : Boolean,
			default : false
		},    
	},

	watch: {    
		modelValue: {
			handler(val) {
				this.formattaInUscita(val);
			},
			deep: true
		},
		api: {
			handler(val) {
				if (val && val != this.lastApi){
					this.lastApi = val;
					this.options = new Array();
					this.currentQuery = "";
					this.doFind();
				}
			}
		},
	},

  	methods: {
		asyncFind (query) {
			this.options = new Array();
			if (query.length > 2){
				this.currentQuery = query;
				utils.wait(()=>{
					if (this.currentQuery == query) {
						this.doFind();
					}
				},500);			
			}
		},
		doFind(){
			this.isLoading = true;
			utils.ajax(this.api,{q:this.currentQuery}, (response) => {
				this.options = response.data;
				utils.appoggio['select2_'+this.CURRENT_TIME] = response.data;
				this.isLoading = false;
			},false);
		},
		formattaInUscita(selectedOption,id){
			if (selectedOption != undefined){
				if (selectedOption.hasOwnProperty("id")){
					this.$emit('update:modelValue',selectedOption.id);
					this.currentId = selectedOption.id
				}
				else{
					if (selectedOption > 0){
						this.currentId = selectedOption;
						this.$emit('update:modelValue',selectedOption);
					}          
				}
			}
    	},
		clearAll:function(){
			this.selectedOption = {id:0,text:''}	;
			this.currentId = 0;
			this.formattaInUscita(this.selectedOption,0);
		},
		
		setOption(val = []) {      
			this.setValue(this.modelValue);
		},

    	setValue(val) {
			if (val instanceof Array) {
				/*
				this.select2.val([...val]);
				this.select2.trigger('change');
				*/
			} 
        	else {
				if (this.apiselected != null && val > 0){
					global.utils.ajax(this.apiselected,{q:val}, (response) => {
						if (response.hasOwnProperty('data')){
							this.$forceUpdate();
						}
					},false);
				}
				else{
					/*
					this.select2.val([val]);
					this.select2.trigger('change');
					*/
				}
      		}
    	},

		onSelect : function(){
			//console.log("alerting");
			//this.changeHandler();
		}

	},

  	mounted() {
		this.GET_OPZIONI = () => {
			return this.options;
		}
    	return;
	},
};
</script>
